import { getNetworkStatus, getUserMasterData } from '../../../selectors/selector';
import { connect } from 'react-redux';
import React from 'react';
import { createStructuredSelector } from 'reselect';
import { UserProfile } from '../../../web/pages/userProfile/userProfile';
import { withRouter } from 'react-router';
import { showNetworkAlert } from '../../../actions/App/action';

const ProfileContainer: React.FC<any> = (props: any) => {

    return <UserProfile {...props}/>
}
const mapStateToProps = createStructuredSelector({
    userDetails: getUserMasterData(),
    isNetworkAvailable: getNetworkStatus()
  });
  
export const mapDispatchToProps = (dispatch: Function) => ({
    showNetworkAlert: () => dispatch(showNetworkAlert()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProfileContainer));